// extracted by mini-css-extract-plugin
module.exports = {"card":"_55b41b3","highlightDisabled":"_3a8993c"};